import React from "react";
import { Helmet } from "react-helmet";
import useAuth, { AuthProvider } from "./context/AuthContext";
import { useTracking } from "./lib/utils/hooks";
import { MainNavigator } from "./navigator/MainNavigator";

function App() {
  useTracking("G-XXE9Y4G4G0");

  const {
    state: { isLowBandwidth },
  } = useAuth();
  React.useEffect(() => {
    if (isLowBandwidth) {
      const imgArr = Array.from(
        document.querySelectorAll("body > img#will-hide")
      );

      imgArr.forEach((img) => {
        img.style.display = "none";
        img.style.background = "#ccc";
      });
    } else {
      const imgArr = Array.from(document.querySelectorAll("img#will-hide"));

      imgArr.forEach((img) => {
        img.style.display = "block";
      });
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta itemprop="name" content="GrEEn" />
        <meta itemprop="description" content="Find Green Oppurtunities" />
        <meta
          itemprop="image"
          content="http://greenghana.com.gh/static/media/hero.780555d8.jpg"
        />
        <meta property="og:title" content="GrEEn" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="Find GrEEn Oppurtunities." />
        <meta
          property="og:image"
          content="https://greenghana.com.gh/static/media/hero.780555d8.jpg"
        />
        <meta property="og:url" content="https://greenghana.com.gh/" />
        <meta property="twitter:title" content="GrEEn" />
        <meta property="twitter:type" content="website" />
        <meta
          property="twitter:description"
          content="Find GrEEn Oppurtunities."
        />
        <meta
          property="twitter:image"
          content="https://greenghana.com.gh/static/media/hero.780555d8.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <AuthProvider>
        <MainNavigator />
      </AuthProvider>
    </>
  );
}

export default App;
